/**
 * Csv Schema of ResponsavelHistoricoSms
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ResponsavelHistoricoSms} from '@/model/resource/ResponsavelHistoricoSms'

/* TODO: review generated schema */
export class CsvResponsavelHistoricoSmsSchema extends Schema {
  readonly name = 'CsvResponsavelHistoricoSms'

  readonly fieldSet: FieldSet<ResponsavelHistoricoSms> = {
    idHistoricoPk: schema => schema.model.idHistoricoPk,
    carga: schema => schema.model.carga?.$id ?? null,
    motorista: schema => schema.model.motorista?.$id ?? null,
    typeSms: schema => schema.model.typeSms?.$id ?? null,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    nomeDestinatario: schema => schema.model.nomeDestinatario,
    mensagem: schema => schema.model.mensagem,
    dataEnvio: schema => Helper.datetime(schema.model.dataEnvio),
    nfe: schema => schema.model.nfe,
    telefone: schema => Helper.phone(schema.model.telefone),
  }
}
